<template>
  <a-modal
    :visible="visible"
    :width="1000"
    title="编辑记录"
    :footer="null"
    @cancel="$emit('cancel')"
  >
    <a-table
      :loading="loading"
      :columns="columns"
      :data-source="list"
      :pagination="pagination"
      bordered
      row-key="id"
      size="small"
    >
    </a-table>
  </a-modal>
</template>
<script>
import { contract_id_records } from '@/api/contract';
export default {
  props: {
    visible: Boolean,
    info: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      columns: [
        {
          title: '原关联用户',
          dataIndex: 'old_user.name',
          customRender: (_, record) => {
            return record.old_user ? record.old_user.name : '';
          },
        },
        {
          title: '新关联用户',
          dataIndex: 'new_user.name',
          customRender: (_, record) => {
            return record.new_user ? record.new_user.name : '';
          },
        },
        {
          title: '操作人',
          dataIndex: 'handle_user.name',
          customRender: (_, record) => {
            return record.handle_user ? record.handle_user.name : '';
          },
        },
        {
          title: '备注',
          dataIndex: 'remark',
        },
        {
          title: '操作时间',
          dataIndex: 'create_time',
        },
      ],
      pagination: {
        current: 1,
        hideOnSinglePage: true,
        onChange: (page) => {
          this.pagination.current = page;
          this.gets();
        },
      },
      loading: false,
      queryParam: { eq: {} },
      list: [],
    };
  },
  watch: {
    visible(a) {
      if (a) {
        this.queryParam.eq = { contract_id: this.info.id };
        this.gets(1);
      }
    },
  },
  methods: {
    async gets(current) {
      this.loading = true;
      if (current) {
        this.pagination.current = current;
      }
      let res = await contract_id_records({
        current: this.pagination.current,
        qp: JSON.stringify(this.queryParam),
      });
      this.list = res.data || [];
      this.$set(this.pagination, 'total', res.total);
      this.loading = false;
    },
  },
};
</script>
